import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/future/image';
import cn from 'classnames';
import Tooltip from './Tooltip';
import checkmark from '@/public/icons/product/checkmark.svg';
import checkmarkBlack from '@/public/icons/product/checkmarkBlack.svg';
import { getContrastYIQ } from '@/lib/collections/helpers';
import { ColorOptionProps } from './types';

const ColorOption = ({
  id,
  setCurrentColor,
  offerColor,
  isSelected,
  option,
  suggested,
  queryParams,
  handleVariantSelection,
  colors,
  className,
}: ColorOptionProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <div className={cn('relative', className)}>
      <Link
        key={option}
        href={{
          pathname: '/collections/[handle]',
          query: queryParams.toString(),
        }}
        scroll={false}
        shallow
      >
        <a
          data-suggested={suggested}
          id={id}
          onClick={() => {
            setIsTooltipOpen(false);
            handleVariantSelection();
          }}
          onMouseEnter={() => {
            setCurrentColor(option);
            if (suggested) setIsTooltipOpen(true);
          }}
          onMouseLeave={() => {
            setCurrentColor(offerColor);
            if (suggested) setIsTooltipOpen(false);
          }}
          className={cn(
            'border-offset-2 flex h-8 w-8 items-center justify-center rounded-full border',
            {
              'border-slate-gray-200 hover:border-gray-700': !isSelected,
              'border-gray-700': isSelected,
              'border-dashed': suggested,
            },
          )}
        >
          <div
            className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full"
            // eslint-disable-next-line react/forbid-dom-props
            style={{ backgroundColor: colors[option] }}
          >
            {isSelected && (
              <div className="flex h-3 w-3 items-center justify-center">
                <Image
                  src={
                    getContrastYIQ(
                      (colors?.[option] ?? '#ffffff').replace('#', ''),
                    ) === 'white'
                      ? checkmark
                      : checkmarkBlack
                  }
                  alt={colors[option]}
                  className="h-full w-full"
                />
              </div>
            )}
          </div>
        </a>
      </Link>
      {isTooltipOpen && <Tooltip />}
    </div>
  );
};

export default ColorOption;
